var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slim"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /~/vue-loader/lib/template-compiler?{"id":"data-v-1e8c4e74","hasScoped":false,"buble":{"transforms":{}}}!/~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/vue/vendor/slim/slim.vue
// module id = 413
// module chunks = 0